import * as XLSX from 'xlsx';
import { message } from 'antd';

// export const handleFileUpload = (file, validateData, setShow) => {
// 	const reader = new FileReader();
// 	reader.onload = (e) => {
// 		try {
// 			const data = e.target.result;
// 			const workbook = XLSX.read(data, { type: 'array' });
// 			const sheetName = workbook.SheetNames[0];
// 			const sheet = workbook.Sheets[sheetName];
// 			const Data = XLSX.utils.sheet_to_json(sheet);
// 			// Process 'excelData' as needed
// 			message.success('Excel file processed successfully.');

// 			validateData(Data);
// 			setShow(true);
// 		} catch (error) {
// 			console.error('Error processing Excel file:', error);
// 			message.error('Error processing Excel file.');
// 		}
// 	};

// 	reader.readAsArrayBuffer(file);
// };

export const handleFileUpload = (file, validateData, setShow, messageApi) => {
	const reader = new FileReader();
	reader.onload = (e) => {
		try {
			const data = e.target.result;
			const workbook = XLSX.read(data, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];

			// --- START: NEW ROBUST CODE ---
			// 1. Get the range of the sheet
			const range = XLSX.utils.decode_range(sheet['!ref']);
			let lastColumn = -1;

			// 2. Find the last column with a header in the first row (row 0)
			for (let C = range.s.c; C <= range.e.c; ++C) {
				const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: C });
				const cell = sheet[cellAddress];
				// If the cell exists and has a value, update the last valid column
				if (cell && cell.v) {
					lastColumn = C;
				}
			}

			// 3. If we found a valid last column, update the sheet's range
			if (lastColumn > -1) {
				range.e.c = lastColumn; // e.g., Set the end column to the last one with a header
				sheet['!ref'] = XLSX.utils.encode_range(range);
			}
			// --- END: NEW ROBUST CODE ---

			// 4. Now, convert to JSON. It will only use the new, smaller range.
			const jsonData = XLSX.utils.sheet_to_json(sheet);

			if (messageApi) {
				messageApi.success('Excel file processed successfully.');
			}

			validateData(jsonData);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			if (messageApi) {
				messageApi.error('Error processing Excel file.');
			}
		}
	};

	reader.readAsArrayBuffer(file);
};

export const fillEmptyCellWithEmptyString = (data) => {
	const allKeys = new Set();
	data.forEach((obj) => {
		Object.keys(obj).forEach((key) => allKeys.add(key));
	});

	// Step 2: Fill missing keys with empty string
	const filledData = data.map((obj) => {
		const filledObj = {};
		allKeys.forEach((key) => {
			filledObj[key] = key in obj ? obj[key] : '';
		});
		return filledObj;
	});

	return filledData;
};

export const handleFileUploadWithDefaultHeader = (file, validateData, setShow, defaultHeader) => {
	const reader = new FileReader();

	reader.onload = (e) => {
		try {
			const data = e.target.result;
			const workbook = XLSX.read(data, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];
			const Data = XLSX.utils.sheet_to_json(sheet, {
				header: defaultHeader,
				range: 1,
				defval: '',
			});

			// Process 'excelData' as needed
			message.success('Excel file processed successfully.');

			validateData(Data);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			message.error('Error processing Excel file.');
		}
	};

	reader.readAsArrayBuffer(file);
};

export const handleFileUploadAOA = (file, validateData, setShow) => {
	const reader = new FileReader();
	reader.onload = (e) => {
		try {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: 'array' });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const aoa = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
			// Process 'excelData' as needed
			message.success('Excel file processed successfully.');

			validateData(aoa);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			message.error('Error processing Excel file.');
		}
	};

	reader.readAsArrayBuffer(file);
};

export const exportExcelFile = (exportData, fileName) => {
	const ws = XLSX.utils.json_to_sheet(exportData);
	const columnWidths = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
	ws['!cols'] = columnWidths;
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'My Sheet');
	const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const blob = new Blob([wbout], { type: 'application/octet-stream' });
	const url = window.URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	anchor.click();
	window.URL.revokeObjectURL(url);
};

export const exportWithData = (exportData, fileName, columnsToExport) => {
	const dataToExport = exportData.map((item) => {
		const filteredItem = {};
		columnsToExport?.forEach((col) => {
			filteredItem[col] = item[col] || '';
		});
		return filteredItem;
	});
	const wb = XLSX.utils.book_new();
	const ws = XLSX.utils.json_to_sheet(dataToExport);
	XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
	XLSX.writeFile(wb, fileName);
};
